import { genericCallWithBody, genericDeleteWithParameters, genericGetWithParameters } from './Networking';


export async function getEntityProperties(entityID, entityType) {
    try{
        let params = {
            'EntityType': entityType,
            'EntityId': entityID,
            'Page': 0,
            'Items': 0,
        };
        let response = await genericGetWithParameters('EntityProperty/GetPropertiesByEntityId', params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveEntityProperty(model){
    var method = 'POST';
    var apiName = 'EntityProperty/SaveByEntityId';
    let response = await genericCallWithBody(method,apiName,model);
    return response;
}

export async function deleteEntityProperty(id){
    let params = {
        'entityPropertyId': id,
    };
    let response = await genericDeleteWithParameters('EntityProperty/Delete',params);
    return response;
}

export async function getEntityOnlineProperties(entityID, entityType) {
    try{
        let params = {
            'entityType': entityType,
            'entityID': entityID,
            'Page': 1,
            'Items': 100
        };
        let response = await genericGetWithParameters('EntityProperty/GetAdditionalProperties', params);
        return response;
    } catch (error) {
        console.error(error);
    }
}
export async function saveAdditionalPropertyInfo(model){
    var method = 'POST';
    var apiName = 'EntityProperty/SaveAdditionalProperty';
    let response = await genericCallWithBody(method,apiName,model);
    return response;
}
export async function deleteEntityOnlineProperties(id){
    let params = {
        'EntityAdditionalPropertyID': id,
    };
    let response = await genericDeleteWithParameters('EntityProperty/DeleteAdditionalProperty',params);
    return response;
}

export async function getPropertiesForDealHeader(entityID, entityType) {
    try{
        let params = {
            'EntityType': entityType,
            'EntityId': entityID,
            'Page': 0,
            'Items': 0,
        };
        let response = await genericGetWithParameters('EntityProperty/GetPropertiesForDealHeader', params);
        return response;
    } catch (error) {
        console.error(error);
    }
}